var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckupList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9165 3.75H4.4165C3.75346 3.75 3.11758 4.01339 2.64874 4.48223C2.1799 4.95107 1.9165 5.58696 1.9165 6.25V21.25C1.9165 21.913 2.1799 22.5489 2.64874 23.0178C3.11758 23.4866 3.75346 23.75 4.4165 23.75H16.9165C17.5795 23.75 18.2154 23.4866 18.6843 23.0178C19.1531 22.5489 19.4165 21.913 19.4165 21.25V6.25C19.4165 5.58696 19.1531 4.95107 18.6843 4.48223C18.2154 4.01339 17.5795 3.75 16.9165 3.75H14.4165",
    stroke: "#ED7047",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9165 3.75C6.9165 3.08696 7.1799 2.45107 7.64874 1.98223C8.11758 1.51339 8.75346 1.25 9.4165 1.25H11.9165C12.5795 1.25 13.2154 1.51339 13.6843 1.98223C14.1531 2.45107 14.4165 3.08696 14.4165 3.75C14.4165 4.41304 14.1531 5.04893 13.6843 5.51777C13.2154 5.98661 12.5795 6.25 11.9165 6.25H9.4165C8.75346 6.25 8.11758 5.98661 7.64874 5.51777C7.1799 5.04893 6.9165 4.41304 6.9165 3.75Z",
    stroke: "#ED7047",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9165 15H6.929",
    stroke: "#ED7047",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9165 18.75H6.929",
    stroke: "#ED7047",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 17.5L11.9165 18.75L15.6665 15",
    stroke: "#ED7047",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckupList);
export default __webpack_public_path__ + "static/media/checkup-list.9657666f35037275b0ec32754aa68418.svg";
export { ForwardRef as ReactComponent };